import React, { Component } from 'react';
import { connect } from 'react-redux'
import { replace } from 'connected-react-router'
import SigningActions from '../../reducers/signingRedux'
import LoadingSpinner from '../Loading/loadingSpinner'
import '../App/style.css'

class ESignatureCallback extends Component {
    constructor(props) {
        super(props)

        this.state = {
            location: props.location,
            signingCompleteRoute: props.signingCompleteRoute,
            loginCallbackStatus: props.loginCallbackStatus
        }
    }

    getCallbackParam = (name) => {
        const search = (window.location && window.location.search) || '';
        const hash = (window.location && window.location.hash) || '';
        const searchParams = new URLSearchParams(search);

        if (searchParams.get(name)) {
            return searchParams.get(name);
        }

        if (hash && hash.includes('?')) {
            const hashQuery = hash.substring(hash.indexOf('?') + 1);
            const hashParams = new URLSearchParams(hashQuery);
            if (hashParams.get(name)) {
                return hashParams.get(name);
            }
        }

        return null;
    }

    componentDidMount() {
        // After a full-page Adobe Sign redirect, Redux state is wiped on reload.
        // Restore envelopeId/recipientId/signingCompleteRoute from sessionStorage
        // so the saga can call the backend to process the signed document.

        const storedEnvelopeId = sessionStorage.getItem('signingEnvelopeId')
            || this.getCallbackParam('envelopeId')
            || this.getCallbackParam('agreementId');
        const storedRecipientId = sessionStorage.getItem('signingRecipientId')
            || this.getCallbackParam('recipientId')
            || this.getCallbackParam('participantSetId')
            || this.getCallbackParam('participantId');
        const storedCompleteRoute = sessionStorage.getItem('signingCompleteRoute');

        if (storedEnvelopeId) {
            this.props.setSigningUri(null, storedEnvelopeId, storedRecipientId || null);
        }
        
        if (storedCompleteRoute) {
            this.setState({ signingCompleteRoute: storedCompleteRoute });
        }

        this.props.processDocumentCallback('in_progress')
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location !== this.props.location) {
            this.setState({ location: this.props.location })
        }

        if (prevProps.signingCompleteRoute !== this.props.signingCompleteRoute) {
            this.setState({ signingCompleteRoute: this.props.signingCompleteRoute })
        }

        if (prevProps.signingCallbackStatus !== this.props.signingCallbackStatus) {
            this.setState({ signingCallbackStatus: this.props.signingCallbackStatus })

            if (this.props.signingCallbackStatus === 'complete') {
                sessionStorage.removeItem('signingEnvelopeId');
                sessionStorage.removeItem('signingRecipientId');
                sessionStorage.removeItem('signingCompleteRoute');
                var route = this.props.signingCompleteRoute || this.state.signingCompleteRoute || '/dashboard'
                this.props.replaceNav(route)
            }

            if (this.props.signingCallbackStatus === 'failed') {
                var route = this.props.signingCompleteRoute || this.state.signingCompleteRoute || '/dashboard'
                this.props.replaceNav(route)
            }
        }
    }

    render() {
        return (
            <div className='callBackLoadingContainer'>
                <LoadingSpinner />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        location: state.router.location,
        signingCompleteRoute: state.signing.signingCompleteRoute,
        signingCallbackStatus: state.signing.signingCallbackStatus,
    }
}

const mapDispatchToProps = (dispatch) => ({
    replaceNav: (route) => dispatch(replace(route)),
    processDocumentCallback: (status) => dispatch(SigningActions.processDocumentCallback(status)),
    setSigningUri: (signingUri, envelopeId, recipientId) => dispatch(SigningActions.setSigningUri(signingUri, envelopeId, recipientId))
})

export default connect(mapStateToProps, mapDispatchToProps)(ESignatureCallback)